import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

interface TimerProps {
  startDateTime: string;
  onTimeEnds?: () => void;
}

const SessionTimer: React.FC<TimerProps> = ({ startDateTime, onTimeEnds }) => {
  const [remainingTime, setRemainingTime] = useState<number>(60 * 60);

  useEffect(() => {
    const startTime = dayjs(startDateTime);
    const currentTime = dayjs();
    const elapsedSeconds = currentTime.diff(startTime, 'second');
    const initialRemainingTime = Math.max(60 * 60 - elapsedSeconds, 0);
    setRemainingTime(initialRemainingTime);
    const interval = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          if (onTimeEnds) {
            onTimeEnds();
          }
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [startDateTime]);

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `00:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };
  return remainingTime < 3600 ? (
    <h3 className='text-xl'>{formatTime(remainingTime < 3600 ? remainingTime : 0)}</h3>
  ) : (
    ''
  );
};

export default SessionTimer;
